import { render, staticRenderFns } from "./CardPromotions.vue?vue&type=template&id=6612456e&scoped=true&"
import script from "./CardPromotions.vue?vue&type=script&lang=js&"
export * from "./CardPromotions.vue?vue&type=script&lang=js&"
import style0 from "./CardPromotions.vue?vue&type=style&index=0&id=6612456e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6612456e",
  null
  
)

export default component.exports